import React, {useMemo, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AppBar from "./AppBar";
import ImagePreview from "./ImagePreview";
import ActionsContainer from "./ActionsContainer";
import ToolbarContainer from "./ToolbarContainer";
import ToolbarContent from "./ToolbarContent";
import Box from "@material-ui/core/Box";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import {Trans} from "react-i18next";

const useStyles = makeStyles(theme => ({
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'white',
    height: '148px',
    zIndex: '2'
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  quantityContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    marginBottom: theme.spacing(2),
  },
  quantityButton: {
    width: '64px',
    height: '64px'
  },
  inputQuantity: {
    width: '64px',
    height: '64px',
    border: '2px solid ' + theme.palette.primary.main,
    boxSizing: 'border-box',
    fontSize: '24px',
    textAlign: 'center',
    lineHeight: '64px',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
}))

const ChangeQuantity = ({setQuantity, onCancel, orderLine}) => {
  const classes = useStyles();
  const { getProductByUuid} = usePriceList();
  const minimumQuantity = useMemo(() => {
    return parseInt(getProductByUuid(orderLine.product.uuid).minorderpartquantity);
  }, [])
  const [currentQuantity, setCurrentQuantity] = useState(() => {
    return orderLine.quantity
  });

  console.log('Minimum qty', minimumQuantity);

  const decreaseQuantity = () => {
    setCurrentQuantity((currentQuantity => {
      let qty = currentQuantity-1;
      if (qty < minimumQuantity) {
        qty = minimumQuantity;
      }
      return qty;
    }))
  }

  const increaseQuantity = () => {
    setCurrentQuantity(currentQuantity+1)
  }

  const onChange = e => {
    setCurrentQuantity(e.target.value);
  }

  const onBlur = e => {
    if (isNaN(e.target.value) || parseInt(currentQuantity) < minimumQuantity) {
      setCurrentQuantity(minimumQuantity)
    }
    else {
      setCurrentQuantity(e.target.value);
    }
  }

  return <div className={classes.mainContainer}>
    <AppBar onCancel={onCancel} />

    <ImagePreview orderLine={orderLine} overrideQuantity={currentQuantity}/>

    <ToolbarContainer>
      <ToolbarContent>
        <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
          <ul className={classes.quantityContainer}>
            <li>
              <Button variant='contained' className={classes.quantityButton} color="primary" onClick={e => decreaseQuantity()}>
                -
              </Button>
            </li>
            <li>
              <input type="text" value={currentQuantity} className={classes.inputQuantity} onChange={onChange}
                     onBlur={onBlur}/>
            </li>
            <li>
              <Button variant='contained' className={classes.quantityButton} color="primary" onClick={e => increaseQuantity()}>
                +
              </Button>
            </li>
          </ul>
        </Box>
      </ToolbarContent>
      <ActionsContainer>
        <Button color="primary" onClick={onCancel}><Trans>Cancel</Trans></Button>
        <Button color="primary" onClick={() => setQuantity(currentQuantity)}><Trans>Done</Trans></Button>
      </ActionsContainer>
    </ToolbarContainer>
  </div>
}

export default ChangeQuantity;